// @flow

const cache: { [times: number]: RegExp } = {};

export function timesGroupFormatter(times: number = 1, value?: ?string = '', separator?: ?string): string {
  return timesGroupSplitter(times, value).join(separator || ' ');
}

export function timesGroupSplitter(times: number = 1, value?: ?string = ''): string[] {
  if (!value) {
    return [];
  }

  const regexp = (cache[times] = cache[times] || new RegExp(`(?:.{1,${times}})`, 'g'));

  return value.match(regexp) || [];
}

export function timesGroupSlicer(times: number = 1, value?: ?ImmutableArray<string> = []): string[][] {
  if (!value) {
    return [];
  }

  const groups: string[][] = [];

  for (let i = 0, group; (group = value.slice(i, i + times)).length; i += times) {
    groups.push(group);
  }
  return groups;
}
